import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteAhjFeeScheduleMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeleteAhjFeeScheduleMutation = { __typename?: 'mutation_root', delete_ahj_fee_schedules_by_pk?: { __typename?: 'ahj_fee_schedules', id: any } | null };


export const DeleteAhjFeeScheduleDocument = gql`
    mutation deleteAhjFeeSchedule($id: uuid!) {
  delete_ahj_fee_schedules_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteAhjFeeScheduleMutationFn = Apollo.MutationFunction<DeleteAhjFeeScheduleMutation, DeleteAhjFeeScheduleMutationVariables>;

/**
 * __useDeleteAhjFeeScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteAhjFeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAhjFeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAhjFeeScheduleMutation, { data, loading, error }] = useDeleteAhjFeeScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAhjFeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAhjFeeScheduleMutation, DeleteAhjFeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAhjFeeScheduleMutation, DeleteAhjFeeScheduleMutationVariables>(DeleteAhjFeeScheduleDocument, options);
      }
export type DeleteAhjFeeScheduleMutationHookResult = ReturnType<typeof useDeleteAhjFeeScheduleMutation>;
export type DeleteAhjFeeScheduleMutationResult = Apollo.MutationResult<DeleteAhjFeeScheduleMutation>;
export type DeleteAhjFeeScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteAhjFeeScheduleMutation, DeleteAhjFeeScheduleMutationVariables>;